import { Component } from '@angular/core';
import { AppConfigurationState } from '@app/features/app-content/states/app-configuration.state';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-page-name-error',
  templateUrl: './page-name-error.component.html',
  styleUrl: './page-name-error.component.scss',
  standalone: false,
})
export class PageNameErrorComponent {
  @Select(AppConfigurationState.pageNameError)
  pageNameError$: Observable<boolean>;
}
